import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const AsoAnalyticWrapper = styled.div`
  .content-wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 1200px;
    min-height: 708px;
    width: 100%;
    background-color: rgb(249, 249, 249);
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    text-transform: uppercase;
    z-index: 1;

    :before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      content: '';
      background-color: rgba(0, 0, 0, .5);
    }

    span { font-size: 28px; text-shadow: 0 0 1px #000; }
  }

  .app-summaries {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 36px;
    padding: 40px 42px;
    padding-bottom: 0;
  }

  .grid-score-summaries { padding: 26px 43px 36px 43px; }
  .grid-score-summaries .summary-title {
    font-family: 'Montserrat';
    font-size: 22px;
    font-weight: 600;
    color: rgba(64, 55, 57, 1);
    text-align: left;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .consultant-request-wrapper {
    position: relative;
    margin: 0 auto;
    margin-bottom: 28px;
    border: 1px solid rgba(60, 211, 207, 1);
    width: 600px;
    background-color: rgba(12, 183, 148, 1);
    cursor: pointer;
    border-radius: 30px;
    box-shadow: 0px 4px 0px 0px rgba(37, 156, 153, 1);

    :active { top: 2px; box-shadow: 0px 2px 0px 0px rgba(37, 156, 153, 1); }
  }
  .consultant-request-wrapper .consultant-request {
    padding: 17px 28px;
    font-family: 'Montserrat';
    font-size: 22px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    letter-spacing: 0.01em;
    text-transform: uppercase;
  }

  @media screen and (max-width: 767px) {
    .content-wrapper { padding: 0 16px auto; }
    
    .app-summaries { flex-wrap: wrap; margin-bottom: 0; padding: 21px 19px; }

    .grid-score-summaries { padding: 32px 5px 11px 5px; }
    .summary-title { padding: 0 17px; text-align: justify; }

    .consultant-request-wrapper { width: auto; margin: 0 21px auto; margin-bottom: 28px; border-radius: 55px; }
  }
`;
export default WithDirection(AsoAnalyticWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/Wrapper.js